var map = {
	"./asset.png": 886,
	"./bells.png": 423,
	"./bnb.png": 887,
	"./btc.png": 888,
	"./calandar.png": 889,
	"./coin.png": 890,
	"./create.png": 891,
	"./currency.png": 892,
	"./dashboard.png": 893,
	"./down.png": 894,
	"./eth.png": 895,
	"./fund.png": 896,
	"./james.png": 190,
	"./logo.png": 897,
	"./logo2.png": 425,
	"./logo3.png": 898,
	"./mail.png": 422,
	"./news.png": 899,
	"./price.png": 900,
	"./report.png": 901,
	"./settings.png": 902,
	"./social/defipulse.png": 426,
	"./social/discord.svg": 427,
	"./social/discord_white.svg": 262,
	"./social/gitbook.svg": 428,
	"./social/github.svg": 429,
	"./social/medium.svg": 430,
	"./social/telegram.svg": 431,
	"./social/twitter.svg": 432,
	"./up.png": 903,
	"./user.png": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;